import { z, ZodError } from 'zod';

const urlOrPath = z.union([z.string().url(), z.string().regex(/^\/(?!\/).+/)]);

export const envSchema = z.object({
  VITE_CLIENT_API: urlOrPath,
  VITE_AUTH_API: z.string().min(1),
  VITE_AUTH_TENANT: z.string().min(1),
  VITE_SOCKET_URL: z.string().url(),
  VITE_SENTRY_URL: z.string().url(),
  VITE_CLIENT_URL: z.string().url(),
  VITE_SESSION_TOKEN_FRONTEND_DOMAIN: z.string(),
  VITE_PUSHER_BEAMS_INSTANCE_ID: z.string(),
});

export type EnvSchema = z.infer<typeof envSchema>;

try {
  envSchema.parse(import.meta.env);
} catch (error) {
  if (error instanceof ZodError) {
    console.error('Environment validation error:', error.errors);
  }
}

const envVariables = envSchema.parse(import.meta.env);

export const safeEnv = envVariables;
